<div>
  <div class="communication-preference-container" *ngIf="user">
    <error-message [host]="this"></error-message>
    <app-form action="/cancelMembership" [handler]="this" class="form-fields">
      <div style="text-align:center;" *ngIf="submitting">
        <app-spinner></app-spinner>
        Saving your preferences...
      </div>
      <div *ngIf="!submitting && submitSuccess">
        <div class="alert alert-success" *ngIf="submitSuccess">
          Your newsletter preferences have been saved!
        </div>

        <a class="btn-2" routerLink="/home">Home</a>
        <a class="btn-2 btn-cancel" (click)="submitSuccess = false">Redo</a>
      </div>
      <div *ngIf="!submitting && !submitSuccess">
        <div class="content-box">
          <label *ngFor="let pref of emailPrefs" class="checkbox-label">
            <input type="checkbox" (change)="submitSuccess = false" [(ngModel)]="pref.allowed">
            {{pref.label}}
          </label>
        </div>
        <div class="note">
          You will receive your chosen newsletters at the address associated with your TYT account, which is
          <strong>{{user.email}}</strong><br /><br />
        </div>

        <div class="alert alert-success" *ngIf="submitSuccess">
          Your newsletter preferences have been saved!
        </div>

        <div class="submit-buttons">
          <button class="btn-2">Save Changes</button>
          <a class="btn-2 btn-cancel" routerLink="/settings">Cancel</a>
        </div>

        <br />
        <br />
        <br />
        <div class="alert alert-warning">
          <strong>Looking for push notification settings for TYT for iOS / Android?</strong><br />
          Open the TYT app on your phone, tap the Settings menu in the upper right and choose Communication Preferences.
        </div>
      </div>
    </app-form>

  </div>
</div>